
// 这个老项目 是直接使用的rem 单位 所以进行了如下转换
// 设置 rem 函数
function setRem() {
  const salepro = document.documentElement.clientWidth
  const fontSize = salepro * (100 / 1920)
  document.documentElement.style.fontSize = Math.max(fontSize, 10) + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
}



// WEBPACK FOOTER //
// ./src/utils/rem.js